import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import { Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import FruitifyLogo from "./FruitifyLogo";
import { alpha } from "@mui/material/styles";

function ResponsiveAppBar() {
  const navigate = useNavigate();

  return (
    <AppBar
      position="fixed"
      enableColorOnDark
      sx={{
        boxShadow: (theme) => `0 1px 0 ${theme.palette.divider}`,
        bgcolor: (theme) => alpha(theme.palette.background.default, 0.96),
        backgroundImage: "none",
        backdropFilter: "blur(12px)",
        mt: "var(--template-frame-height, 0px)",
      }}
      data-testid={"fruitify-logged-out-navbar"}
    >
      <Container maxWidth="xl">
        <Toolbar sx={{ minHeight: { xs: 72, md: 84 } }}>
          <FruitifyLogo horizontal width={140} />
          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "flex" } }}></Box>
          <Box sx={{ flexGrow: 0 }}>
            <Stack direction={"row"} spacing={1}>
              <Button
                onClick={() => navigate("/help")}
                sx={{ color: "secondary.main" }}
              >
                Help
              </Button>
              <Button
                sx={{
                  my: 2,
                  display: "block",
                  color: "secondary.main",
                }}
                data-testid={"fruitify-login-button"}
                onClick={() => {
                  navigate(`/login`); // Redirect to the specified URL
                }}
              >
                Login
              </Button>
            </Stack>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;
